import React from 'react';
import PropTypes from 'prop-types';
import { Table, Button } from 'antd';

const { Column } = Table;

const RetainerClientDocuments = ({ documents }) => (
  <div className="contentBox" style={{ marginBottom: 20 }}>
    <h2>Documents</h2>
    <Table dataSource={documents} rowKey="id">
      <Column title="Title" dataIndex="title" key="title" />
      <Column title="Description" dataIndex="description" key="description" />
      <Column title="Document Type" dataIndex="docType" key="docType" />
      <Column
        title="Actions"
        key="downloadUrl"
        dataIndex="downloadUrl"
        render={(text) => {
          console.log(text);
          return <Button href={text}>Download</Button>;
        }}
      />
    </Table>
  </div>
);

RetainerClientDocuments.propTypes = {
  documents: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    }),
  ).isRequired,
};

export default RetainerClientDocuments;



// WEBPACK FOOTER //
// ./src/pages/RetainerClientDocuments.jsx